import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FeedbackStudentsPreviewModel } from 'common/models/page-models/Feedback students preview/feedback-students-preview-data-model';
import { FeedbackPreviewModel } from 'common/models/page-models/feedback-preview/feedback-preview-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { FeedbackStudentPreviewWidgetService } from 'common/widget/feedback-mapping/feedback-student-preview-widget.service';

@Injectable({
    providedIn: 'root',
})
export class FeedbackStudentsPreviewResolver extends FormResolverService<FeedbackStudentsPreviewModel> {
    constructor(
        protected fs: FeedbackStudentPreviewWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    // override modifyResponseData(dataModel: any, meta: any, widget: any) {
    //     const previewModel = new FeedbackPreviewModel();

    //     // Set common preview model fields
    //     previewModel["feedbackFormId"] = widget.transferData.transferData.feedback_form_id;
    //     previewModel["feedbackFormMappingId"] = widget.transferData.transferData.feedback_form_mapping_id;

    //     // Populate question answers
    //     // dataModel.details.forEach((question) => {
    //     //     switch (question.question_type) {
    //     //         case 0: // Input type
    //     //         case 5: // TextArea type
    //     //             previewModel[question.id] = question.answer || ""; // Default empty string for text-based fields
    //     //             break;

    //     //         case 1: // Single Choice
    //     //         case 2: // Yes/No
    //     //         case 4: // Dropdown
    //     //             previewModel[question.id] = question.answer || null; // Default to null for select-based fields
    //     //             break;

    //     //         case 3: // Ratings
    //     //             previewModel[question.id] = this.returnStarValue(question.answer || ""); // Calculate star ratings
    //     //             break;

    //     //         case 6: // Multiple Choice
    //     //             previewModel[question.id] = question.options
    //     //                 .filter((option) => option.selected === 1)
    //     //                 .map((option) => option.id); // Collect selected option IDs
    //     //             break;

    //     //         default:
    //     //             previewModel[question.id] = null; // Default fallback
    //     //             break;
    //     //     }
    //     // });

    //     return previewModel;
    // }

    override modifyResponseData(dataModel: any, meta: any, widget: any) {
        const previewModel = new FeedbackPreviewModel();
        // console.log('Widget:', widget);
    
        previewModel['feedbackFormId'] = widget.transferData.transferData.feedback_Form_Id;
        previewModel['feedbackFormMappingId'] = widget.transferData.transferData.feedback_form_mapping_id;
    
        dataModel.forEach((question) => {
            // console.log('Processing question:', question);
    
            if (question.question_type === 3) {
                // Star rating logic
                previewModel[question.id] = this.returnStarValue(question.answer);
            } else if (question.question_type === 2) {
                // Yes/No logic
                previewModel[question.id] = this.getYesNoAnswer(question.answer);
            } else if (question.question_type === 6) {
                // Multiple-choice logic
                const selectedOptionText = this.getSelectedOptionText(question.answer, question.options);
                // console.log(`Question ID: ${question.id}, Selected Answer ID: ${question.answer}, Selected Text: ${selectedOptionText}`);
                previewModel[question.id] = question.answer;
            } else {
                // Default logic for other question types
                console.warn(`Unhandled question type: ${question.question_type}`);
                previewModel[question.id] = question.answer;
            }
        });
    
        // console.log('Transformed Preview Model:', previewModel);
        return previewModel;
    }
    
    getSelectedOptionText(answer: string, options: any[]): string | null {
        if (!options || !Array.isArray(options)) {
            console.error('Options array is invalid:', options);
            return null;
        }
    
        const selectedOption = options.find((option) => option.id === parseInt(answer, 10));
        return selectedOption ? selectedOption.option_text : null;
    }
    
    

    
    returnStarValue(value: string): number {

        return value.split(",").filter((v) => v.trim() === "true").length;
        
    }

    
    getYesNoAnswer(answer: string): number {
        return answer == "0" ? 0 : 1;
    }
}